module.exports = __webpack_public_path__ + "static/media/20ECE19.f716c7d4.jpg";